/**
 * @desc 缓存
 * @author ruoxinhuang
 * @date 2021-09-09
 */
// 字符化
function serialize(val) {
    return JSON.stringify(val);
}
// 反字符化
function deserialize(val) {
    try {
        return JSON.parse(val);
    }
    catch (e) {
        return val || undefined;
    }
}
// 默认存储时间 10年
const DEFAULT_LIFE = 3600 * 24 * 365 * 10;
const DEFAULT_PREFIX = 'store_';
const DEFAULT_VER = 1;
class StorageUtil {
    constructor(config = {}) {
        this.MAX_LIFE = DEFAULT_LIFE;
        this.ver = DEFAULT_VER;
        this.prefix = DEFAULT_PREFIX;
        this.transition = null;
        // 缓存的最长时间
        this.MAX_LIFE = DEFAULT_LIFE;
        // 版本号，主要对于复杂场景，业务迭代过程中数据结构发生了改变，需要对已存在的缓存
        // 做一些处理，配合transition方法，使用方可以根据需要自己处理版本差异问题。
        this.ver = config.ver || 1;
        // 缓存前缀，避免key重复，互相覆盖
        this.prefix = config.prefix || DEFAULT_PREFIX;
        // ver版本不一致时，特殊处理函数
        this.transition = config.transition;
    }
    /**
     * 获取单例
     * @param isNew 是否重新创建
     */
    static getInstance(isNew = false, config = {}) {
        if (!StorageUtil.instance || isNew) {
            StorageUtil.instance = new StorageUtil(config);
        }
        return StorageUtil.instance;
    }
    /**
     * 设置缓存
     * @param key 缓存key
     * @param value 缓存值
     * @param option 缓存参数
     */
    set(key, value, option = {}) {
        const newOption = Object.assign({ life: this.MAX_LIFE, postponable: false }, option);
        newOption.expireOn = Date.now() + newOption.life * 1000;
        const obj = { ver: this.ver, option: newOption, value };
        localStorage.setItem(this.prefix + key, serialize(obj));
    }
    /**
     * 读取指定key的缓存内容
     * @param key 缓存key
     */
    get(key) {
        const strValue = localStorage.getItem(this.prefix + key);
        if (!strValue) {
            return null;
        }
        const { ver, option, value } = deserialize(strValue);
        const currentTime = Date.now();
        if (currentTime >= option.expireOn) {
            this.remove(key);
            return null;
        }
        option.lastAccessTime = currentTime;
        if (option.postponable) {
            this.set(key, value, option);
        }
        if (ver !== this.ver && this.transition) {
            return this.transition(ver, key, value, option);
        }
        return value;
    }
    /**
     * 删除缓存
     * @param key 缓存key
     */
    remove(key) {
        localStorage.removeItem(this.prefix + key);
    }
    /**
     * 清理缓存，只清理本实例创建的, 避免误伤.
     * 若要全部清理, 可直接使用localStorage.clear方法
     */
    clear() {
        const storage = window.localStorage;
        for (let i = 0, len = storage.length; i < len; i++) {
            const key = storage.key(i);
            if (key.startsWith(this.prefix)) {
                localStorage.removeItem(key);
            }
        }
    }
    /**
     * 是否存在这个key
     * @param key
     */
    has(key) {
        if (!key)
            return false;
        return this.get(key) !== undefined;
    }
}
/**
 * 设置缓存
 * @param key 缓存key
 * @param value 缓存值
 * @param option 缓存参数
 */
export function setItem(key, value, option = {}) {
    return StorageUtil.getInstance().set(key, value, option);
}
/**
 * 通过key获取缓存
 * @param key
 */
export function getItem(key) {
    return StorageUtil.getInstance().get(key);
}
/**
 * 删除缓存
 * @param key 缓存key
 */
export function removeItem(key) {
    return StorageUtil.getInstance().remove(key);
}
/**
 * 设置缓存key前缀
 * @param prefix 缓存key前缀
 */
export function setPrefixKey(prefix) {
    // 改变了前缀，需要重新创建单例
    return StorageUtil.getInstance(true, { prefix });
}
